module.exports = __webpack_public_path__ + "static/img/15.7e214cf6.png";